import req from '../req'
// 通用配置

// 企业微信配置-获取配置详情接口
export function getGeneral (params) {
  return req.get('/setting/general', params)
}

// 企业微信配置-保存配置详情接口
export function setGeneral (params) {
  return req.post('/setting/general', params)
}
